// extracted by mini-css-extract-plugin
export var chevronIcon = "_9t-2";
export var teamName = "_9t-1";
export var teamSwitcherButton = "_9t-0";